import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody41';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy41 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Thematic Research & Acquisition </h2><h4>Mapping for a family office with diversified investments</h4>";

  return (
    <>
        <Helmet>
        <title>Thematic Research & Acquisition Mapping for a family office with diversified investments </title>
        <meta property="og:title" content="Thematic Research & Acquisition Mapping for a family office with diversified investments  " />
        <meta property='og:description' content='Thematic Research & Acquisition Mapping for a family office with diversified investments  '/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy41" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy41
